import React from "react";
import EAModal from "../../shared/Modal/EAModal";
import "../../RegisterB2BPage/RegisterB2BStyle.scss";
import RegisterB2BForm from "../../RegisterB2BPage/RegisterB2BForm";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

const RegisterB2B: React.FC<IProps> = ({ isOpen, onClose }: IProps) => {
  return (
    <EAModal isOpen={isOpen} hideButtons onClose={onClose} title="" isCloseButton={true}>
      <div className="b2b-register-container">
        <RegisterB2BForm onGoBack={onClose} />
      </div>
    </EAModal>
  );
};

export default RegisterB2B;
